import React from 'react';
import { Modal } from 'antd';
import { ErrorMsg } from '../../common/stores/ErrorStore';

type RuntimeSchemaDiagnostic = {
    validationMode?: string;
    runtimePath?: string;
    originalPropertyName?: string;
    generatedFieldName?: string;
    generatedModelName?: string;
    fieldAlias?: string;
    expectedBaseName?: string;
    remediation?: string;
    message?: string;
};

function getDiagnostics(error?: ErrorMsg): RuntimeSchemaDiagnostic[] {
    const diagnostics = error?.invalidParams?.find(param => param.name === 'jsonSchemas.outputSchema')?.details
        ?.diagnostics;

    return Array.isArray(diagnostics) ? (diagnostics as RuntimeSchemaDiagnostic[]) : [];
}

function formatDiagnostic(diagnostic: RuntimeSchemaDiagnostic) {
    const parts = [
        diagnostic.validationMode ? `Mode: ${diagnostic.validationMode}` : '',
        diagnostic.runtimePath ? `Runtime path: ${diagnostic.runtimePath}` : '',
        diagnostic.originalPropertyName ? `Original property: ${diagnostic.originalPropertyName}` : '',
        diagnostic.generatedFieldName ? `Generated field: ${diagnostic.generatedFieldName}` : '',
        diagnostic.generatedModelName ? `Generated model: ${diagnostic.generatedModelName}` : '',
        diagnostic.fieldAlias ? `Alias: ${diagnostic.fieldAlias}` : '',
        diagnostic.expectedBaseName ? `Expected base: ${diagnostic.expectedBaseName}` : '',
        diagnostic.message ? `Details: ${diagnostic.message}` : '',
        diagnostic.remediation ? `Fix: ${diagnostic.remediation}` : ''
    ].filter(Boolean);

    return parts.join(' | ');
}

export function showRuntimeSchemaValidationError(error?: ErrorMsg): boolean {
    const isRuntimeSchemaError =
        error?.errorCode === 'runtime_schema_invalid' ||
        (error?.type === 'ValidationError' &&
            error?.invalidParams?.some(param => param.name === 'jsonSchemas.outputSchema'));

    if (!isRuntimeSchemaError) {
        return false;
    }

    const diagnostics = getDiagnostics(error);
    const summary = error?.detail || 'Runtime schema validation failed.';

    Modal.error({
        title: error?.title || 'Runtime schema validation failed',
        width: 760,
        okText: 'Close',
        content: (
            <div>
                <p>{summary}</p>
                {diagnostics.length > 0 ? (
                    <ul style={{ paddingLeft: 20, marginBottom: 0 }}>
                        {diagnostics.map((diagnostic, index) => (
                            <li key={`${diagnostic.runtimePath || 'diagnostic'}-${index}`}>
                                {formatDiagnostic(diagnostic)}
                            </li>
                        ))}
                    </ul>
                ) : null}
            </div>
        )
    });

    return true;
}
